module.exports = __webpack_public_path__ + "media/images/front/bg-214a608af14991d3f43f1bde05e9fe8d.jpg";